// extracted by mini-css-extract-plugin
module.exports = {"singleNumber":"SingleNumber_singleNumber__1YHZi","number":"SingleNumber_number__361Z3","title":"SingleNumber_title__2ZAAU"};